import { styled } from "@mui/styles";
import Card from "@mui/material/Card";

export const StyledEventCard = styled(Card)(({ theme }) => ({
    '& .MuiPaper-root': {
        maxWidth: 345, borderRadius: '10px',
        boxShadow: `10px 10px 10px ${theme.palette.neutral.light}`,
        border: `1px solid ${theme.palette.neutral.light}`
    },
    '& .MuiCardMedia-root': {
        height: '140px',
    },
    '& .DateTimeTag': {
        backgroundColor: theme.palette.primary.main,
        color: 'white',
        padding: '5px 10px',
        width: 'fit-content',
        position: 'absolute',
        left: '0',
        top: '-16px',
        [theme.breakpoints.down('sm')]: {
            fontSize: '10px'
        }
    },
    '& .MuiCardContent-root': {
        position: 'relative',
        paddingBottom: 0
    },
    '& .Title': {
        marginTop: '16px',
        [theme.breakpoints.down('sm')]: {
            marginTop: 0,
            fontSize: '15px'
        }
    },
    '& .Location': {
        marginTop: '24px',
        fontWeight: 600,
        [theme.breakpoints.down('sm')]: {
            marginTop: '15px',
            fontSize: '12px'
        }
    },
    '& .CountryName': {
        [theme.breakpoints.down('sm')]: {
            fontSize: '15px'
        }
    },
    '& .MuiCardActions-root': {
        justifyContent: 'center',
        [theme.breakpoints.down('sm')]: {
            padding: '0 0 5px 0'
        }
    },
    '& .MuiCardMedia-root': {
        [theme.breakpoints.down('sm')]: {
            height: '120px'
        }
    }

}));